import { useQuery } from '@tanstack/react-query'
import {
  getActiveBoxCollections,
  BoxCollection,
} from '../api/boxCollectionsApi'

export const useActiveBoxCollections = () => {
  return useQuery({
    queryKey: ['ActiveBoxCollections'],
    queryFn: getActiveBoxCollections,
    refetchInterval: 1000 * 60 * 5, // Refetch every 5 minutes
    staleTime: 1000 * 60 * 2, // Consider data fresh for 2 minutes
  })
}

export type { BoxCollection }
